import { useEffect, useState } from "react";

import { FormInput, ModalForm, Button, useStyles } from "../../../../components";
import { getPriceStr } from "../../../../lib/utils";
import { useSelector } from "react-redux";
import { ReactComponent as Smile } from '../../../../assets/icons/Smile.svg'
import { Text, BestNewHot, Price, ChangeQty } from "./compos";
import { ItemOptionInfo } from "./ItemOptionInfo";

import { createItemObj2 } from "./createItemObj-testOrder";
import { createCartObj } from "./createCartObj";
import { notifyOrderToStore, goToPayKis, goToPayTQR } from "../../../../lib/pay-api-lib";
// import { getOrderSerialNo } from "../../../../lib/ec2-api-lib";
import { sendOrder } from "../../../../lib-pos/sendOrder";
import { saveOrderDataBeforePay } from "../../../../lib-pos/saveOrderDataBeforePay";

import { debug } from "../../../../settings";


/** @ONL_POS_에서도_사용 */
export function TestOrderModal(props) {
  const {
    shopInfo,
    item, itemList,
    itemOptions2,
    visible,
    setIsVisible,

    // 
    // 포스 모드에서 사용할 때 필요
    // 
    mode,             // ONL_POS | undefined, 
    selectedTableInfo, // ONL_POS only 
    updateOrder
  } = props;
  const { isMobilePhone } = useSelector

  let title = `주문 테스트`;
  if (selectedTableInfo?.tableName) {
    title = `${selectedTableInfo?.tableName} - 주문`
  }

  const [isLoading, setIsLoading] = useState(false)

  const [btnText, setBtnText] = useState("주문")
  const [amount, setAmount] = useState(item.price)
  const [clickEnabled, setClickEnabled] = useState(false)
  const [itemCount2, setItemCount2] = useState(1)
  const [selectedOptions, setSelectedOptions] = useState([])
  const [tableNo, setTableNo] = useState(selectedTableInfo?.tableCode || "012")

  useEffect(() => {
    if (!item.itemName) return // 초기 값이 {} 일 경우 제외
    if (shopInfo.posName === "UNIONPOS") initSelectedOptionsUnionpos()
    if (shopInfo.posName === "OASIS_POS") initSelectedOptionsOasispos()
    if (shopInfo.posName === "EASY_POS") initSelectedOptionsEasypos()
    if (shopInfo.posName === "DUMMY_POS" || shopInfo.posName === "ONL_POS") initSelectedOptionsDpos()
    if (shopInfo.posName === "OKPOS") alert("Options NOT SUPPORTED")
  }, [item])

  /**
   * @TODO shopInfo에 storeCode=shopNo, masterDataKey, headOfficeNo
   */
  const initSelectedOptionsEasypos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        console.log('_selectedOptions', _selectedOptions)
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  const initSelectedOptionsUnionpos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        console.log('_selectedOptions', _selectedOptions)
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  const initSelectedOptionsOasispos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })

        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  const initSelectedOptionsDpos = () => {
    try {
      const obj = createItemObj2({ shopInfo, item, itemList, itemOptions2 })
      if (obj.err) throw Error(obj.err.message)

      if (obj.optionClassList) {
        const _selectedOptions = obj.optionClassList.map((optCls) => {
          return {
            ...optCls,
            optionItems: []
          }
        })
        setSelectedOptions(_selectedOptions)
      }
    } catch (e) {
      alert(e.message)
      setIsVisible(false)
    }
  }

  // 
  // option 메뉴 변경시 invoke
  // 
  useEffect(() => {
    let orderReady = true
    let sum = parseInt(item.price)
    selectedOptions.map((cls) => {
      if (cls.required) orderReady = orderReady && cls.optionItems.length > 0
      cls.optionItems.map((optItem) => {
        sum += optItem.optPrice
      })
    })

    setClickEnabled(orderReady)
    setAmount(sum * itemCount2)
    setBtnText(`주문 (${getPriceStr(sum * itemCount2)} 원)`)

  }, [selectedOptions, itemCount2])

  const onSubmit = async () => {
    try {
      setIsLoading(true)

      const cartItem = createCartObj({
        shopInfo,
        item,
        itemList,
        itemOptions2,
        selectedOptions,
        itemCount: itemCount2,
      })
      if (cartItem.err) throw Error(cartItem.err.message)

      // 
      // 오늘 포스 영업 화면에서 사용 시
      // 
      if (mode === "ONL_POS") return updateOrder(cartItem)

      // 
      // prePay Order
      // 
      if (shopInfo.payOptions.isPayable) return requestPay([cartItem])

      let res = {}

      // 
      // publish order to ONL_POS
      // 
      if (shopInfo.posName === "ONL_POS") {
        const resPub = await publishOrderToONLPOS([cartItem])
        if (resPub.err) {
          if (resPub.err.message.includes("Table in Use")) {
            throw Error("포스가 사용 중입니다. 잠시 후 다시 시도해주세요.")
          }
          if (resPub.err.message.includes("ETIMEOUT")) {
            let errMsg = "포스 서버와 연결이 되지 않습니다. 잠시 후 다시 시도해주세요."
            errMsg += "\n반복되면 관리자에게 문의하세요."

            throw Error(errMsg)
          }
          throw Error(resPub.err.message)
        }
      }

      // 
      // 일반 테스트 주문
      // 
      else {
        res = await requestOrderOnly([cartItem])
        if (res.err) throw Error(res.err.message)
      }
      alert("테스트 주문을 완료하였습니다.");

    } catch (e) {
      alert(e.message);
    } finally {
      setIsLoading(false);
      setIsVisible(false);
    }
  };

  const publishOrderToONLPOS = (cartItems) => {
    return sendOrder({
      shopInfo,
      cartItems,
      itemOptions2,
      tableNo,
      token: "1234",
      ver: "v3",
    })
  }

  const requestOrderOnly = async (cartItems) => {
    try {
      let res = await sendOrder({
        shopInfo,
        cartItems,
        itemOptions2,
        tableNo,
        token: "1234",
        ver: "v3",
      })
      if (res.err) throw Error(res.err.message)

      const orderId = res.result.saveOrder?.orderId

      console.log('orderId', orderId)

      if (
        shopInfo.orderNotifyOptions?.toShop ||
        shopInfo.posName === "DUMMY_POS"
      ) {
        /**
         * @notifyOrder 하면 payServer에서 orderStatus 를생성함 
         *  - payment에서 orderNotify를 처음 하여 그것을 이용한 것임
         *  - orderId만 보내면 서버에서 orderRecord를 불러와서 orderData를 생성
         */
        const resNoti = await notifyOrderToStore({
          shopId: shopInfo.shopId,
          orderId,
          phone_number: '01053174673',
        })
        if (resNoti.err) throw Error(resNoti.err.message)
      }

      return {}
    } catch (e) {
      // console.log(e)
      return { err: { message: e.message } }
    }

  }

  const requestPay = async (cartItems) => {
    try {
      setIsLoading(true)

      let res = await saveOrderDataBeforePay({
        shopInfo,
        cartItems,
        itemOptions2,
        tableNo,
        token: "1234",
        ver: "v3",
        // notifyToShop: shopInfo.orderNotifyOptions.isPayable
      })
      if (res.err) throw Error('결제 | 주문 실패 - ', res.err.message)

      const params = {
        shopId: shopInfo.shopId,
        pgName: shopInfo.payOptions?.pgName,
        orderId: res.result.orderId,
      }

      if (shopInfo.payOptions?.pgName === "KISPG") {
        goToPayKis(params)
      } else if (shopInfo.payOptions?.pgName === "THANKSQR") {
        goToPayTQR(params)
      } else {
        throw Error("WRONG PGNAME")
      }
    } catch (e) {
      alert(e.message)
      if (debug) console.log(e)
    } finally {
      // setIsLoading(false)
    }
  }


  const styles = {
    wrap: {
      display: 'flex',
      flexDirection: isMobilePhone ? "column" : "row",
      justifyContent: 'space-between',
      minHeight: "50vh",
      padding: "0px 5px 15px"
    },
    imgWrap: {
      marginTop: 15,
      width: isMobilePhone ? "100%" : "20vw",
      paddingRight: isMobilePhone ? 0 : 15,
      display: 'flex', flexDirection: "column",
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    infoWrap: {
      width: isMobilePhone ? "100%" : '30vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    sum: {
      marginTop: 15,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }

  return (
    <ModalForm
      visible={visible}
      setIsVisible={setIsVisible}
      title={title}
      size="lg"
      mode={props.mode}
    >
      <div style={styles.wrap}>
        <div style={styles.imgWrap}>
          {item.image ? (
            <img
              src={item.image}
              alt="item menu picture"
              style={{ borderRadius: '15px', width: '90%' }}
            />
          ) : (
            <Smile />
          )}
          {mode !== "ONL_POS" &&
            <FormInput
              label="Table No"
              value={tableNo}
              onChange={(e) => setTableNo(e.target.value)}
            />
          }

        </div>

        <div style={styles.infoWrap}>
          <ItemInfo item={item} />
          <ItemOptionInfo
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
          />
          <div style={styles.sum}>
            <Price
              price={amount}
              style={{ width: '50%' }}
              size="lg"
            />
            <ChangeQty itemCount={itemCount2} setItemCount={setItemCount2} size="lg" />
          </div>
        </div>
      </div>

      <Button
        size="sm"
        variant="primary"
        width="100%"
        title={btnText}
        onClick={onSubmit}
        isLoading={isLoading}
        disabled={!clickEnabled}
      />
    </ModalForm>
  )
}

function ItemInfo({ item }) {

  const styles = {
    wrap: {
      // marginTop: 15,
      // marginBottom: 15,
    },
    title: { margin: '0px 0px 5px' },
    desc: { marginBottom: 5, color: '#666' },
  }

  return (
    <div style={styles.wrap}>
      <BestNewHot item={item} />
      <Text value={item.itemName2} isTitle />
      <Price price={item.price} />
      <Text style={styles.desc} value={item.description} />
    </div>
  )
}
